import { render } from "./ApprovalFormHistoryDetail.vue?vue&type=template&id=b11aa06a&scoped=true"
import script from "./ApprovalFormHistoryDetail.vue?vue&type=script&lang=ts"
export * from "./ApprovalFormHistoryDetail.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-b11aa06a"

export default script